var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"page-wrap DeviceList-page"},[_c('Search',{ref:"search",attrs:{"label":_vm.searchLabel,"dateFilter":true},on:{"search":_vm.search}}),_c('List',{ref:"list",attrs:{"title":"结算列表","refresh":true,"label":_vm.label,"apiName":"petSettlementList"},on:{"itemClick":_vm.itemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }